import { BarChart3, Boxes, Cable, Gavel, LayoutDashboard, ListChecks, MessagesSquare } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

export type NavCommand = {
	id: string;
	to: string;
	labelKey: string;
	shortcut: string;
	icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const NAV_COMMANDS: NavCommand[] = [
	{ id: 'nav-dashboard', to: '/', labelKey: 'sidebar.nav.dashboard', shortcut: 'G D', icon: LayoutDashboard },
	{ id: 'nav-modules', to: '/modules', labelKey: 'sidebar.nav.modules', shortcut: 'G M', icon: Boxes },
	{
		id: 'nav-conversations',
		to: '/conversations',
		labelKey: 'sidebar.nav.conversations',
		shortcut: 'G C',
		icon: MessagesSquare,
	},
	{ id: 'nav-judges', to: '/judges', labelKey: 'sidebar.nav.judges', shortcut: 'G J', icon: Gavel },
	{
		id: 'nav-evaluations',
		to: '/evaluations',
		labelKey: 'sidebar.nav.evaluations',
		shortcut: 'G E',
		icon: ListChecks,
	},
	{
		id: 'nav-reports',
		to: '/reports',
		labelKey: 'sidebar.nav.reports',
		shortcut: 'G R',
		icon: BarChart3,
	},
	{
		id: 'nav-dependencies',
		to: '/dependencies',
		labelKey: 'sidebar.nav.dependencies',
		shortcut: 'G P',
		icon: Cable,
	},
];
